import React, { useEffect, useState } from 'react'
import api from "../../services/api"
import { useNavigate } from 'react-router'
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { formatDate, formatDateWithTime, formatDateYYYYMMDD, ISODateString } from "../../utils/dateFormat";
import { roles } from '../../utils/constants';

function DayWiseReport(object) {
    const campaign_id = object.campaign_id
    const camp = object.camp
    const x_value = camp.x_value
    const navigate = useNavigate()
    const [data,setData] = useState([])
    const [loader, setLoader] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        getdata(campaign_id,event.selected)
      };
    
    const getdata =async (campid=campaign_id,page=0)=>{
        setLoader(true);
        try {
            let res = await api({
                url: '/reports/daywisereports',
                method: 'POST',
                responseType: 'json',
                data: {
                 campid,
                 grouped: camp.grouped,
                 x_value,
                 page,
                 action:"daywise",
                 limit: config.PER_PAGE,
                }
              });
              if (res.code === 200) {
                setData(res.data.totalres);
                setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
              }
              setLoader(false);

        } catch (error) {
            console.error(error);
      if (error.response.status === 401)
        navigate("/")
        }
        
    }
    useEffect(()=>{
        getdata()
    },[])
  return (
    <div>
      <div className="overflow-x-auto mb-4">
        <table className='table table-bordered'>
          <thead>
            <tr>
              {/* Campaign Creation */}
              {/* <th scope="col">Campaign Id</th> */}
             <th scope="col">Date</th>
             {localStorage.getItem('role') === roles.advertiser ? <th>Audience Viewed</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Impressions</th> : <th>Impressions</th>}
              {localStorage.getItem('role') === roles.advertiser ? <th>Audience Engaged</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Clicks</th> : <th>Clicks</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <th scope="col">Advertiser Impressions</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <th scope="col">Advertiser Clicks</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <th scope="col">CTR(%)</th>}
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <th scope="col">ECPM</th>}
              <th scope="col">Spent</th>
              {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <th scope='col'>Advertiser Spent</th>}
              {localStorage.getItem("role") === roles.ops && <th>E Impressions</th>}
              {localStorage.getItem("role") === roles.ops && <th>E Adv Impressions</th>}
              {localStorage.getItem("role") === roles.ops && <th>Actual Clicks</th>}
              {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item._id} >
                    <td >{formatDate(item._id)}</td>
                    <td>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? item.total_imp : parseInt(item.adv_total_imp)}</td>
                    <td>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? item.total_click : parseInt(item.adv_total_click)}</td>
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td >{ parseInt(item.adv_total_imp)}</td>}
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td >{ parseInt(item.adv_total_click)}</td>}
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td title={item.total_click > 0 && item.total_imp > 0 ? (item.total_click / item.total_imp)*100 : 0}>{item.total_click > 0 && item.total_imp > 0 ? ((item.total_click / item.total_imp)*100).toFixed(2) : 0}</td>}
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td title={camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? ((camp.cpc_price * item.total_click) / item.total_imp) * 1000 : camp.campaign_type === "CPM" && item.total_imp > 0 ? camp.cpm : camp.campaign_type === "CPD" ? camp.cpd : "0"}>{camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? (((camp.cpc_price * item.total_click) / (item.total_imp)) * 1000).toFixed(2) : camp.campaign_type === "CPM" && item.total_imp > 0 ? ((((camp.cpm * item.total_imp) / 1000) / item.total_imp) * 1000).toFixed(2) : camp.campaign_type === "CPD" ? camp.cpd : "0"}</td>}
                    <td title={(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.total_imp) / 1000 : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.adv_total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.adv_total_imp) / 1000 : 0) : "0")}>{(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.total_imp) / 1000).toFixed(2) : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>
                    {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) && <td title={(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? parseFloat(camp.cpc_price) * item.adv_total_click : camp.campaign_type === "CPM" ? (parseFloat(camp.cpm) * item.adv_total_imp) / 1000 : 0) : "0")}>{(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.encrypt_imp > 0 ? item?.encrypt_imp : 0)}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.encrypt_adv_imp > 0 ? item?.encrypt_adv_imp : 0)}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.actual_clicks > 0 ? item?.actual_clicks : 0)}</td>}
                    {localStorage.getItem("role") === roles.ops && <td className="p-2">{parseInt(item?.shares > 0 ? item?.shares : 0)}</td>}

                  </tr>

                )
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {totalPages > 1 && <Paginator
          pageCount={totalPages}
          handlePageClick={handlePageClick}
          forcePage={currentPage}
        />
        }
      </div>
    </div>
  )
}

export default DayWiseReport
